﻿<script setup lang="ts">

    import { getApplicationLink } from '@/shared/helpers/routing.ts';
    import { Job, SubscriptionBasedJob } from '@/shared/helpers/api/types/entities.ts';
    import { computed } from 'vue';

    const props = defineProps<{
        job: Job;
    }>();

    const job = computed<SubscriptionBasedJob | null>(() => {
        if (isSubscriptionJob(props.job)) {
            return props.job as SubscriptionBasedJob;
        }
        return null;
    });

    function isSubscriptionJob(job: Job) {
        return Object.hasOwn(job, 'subscription');
    }
</script>

<template>
    <router-link
        v-if="job"
        :to="getApplicationLink(job.subscription.application.name)">
        {{ job.subscription.application.name }}
    </router-link>
</template>

<style scoped>

</style>
